import React from "react";
import { decimalAdjust } from "../../Global";

class DeliveryAgregarDerecha extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            medioPago: "efectivo",
            montoPago: 0,
            vuelto: 0
        }
    }

    calcularVuelto = () => {
        const { productos } = this.props;
        const total = productos.reduce((acc, item) => acc + (item.precio * item.cantidad), 0);
        const vuelto = this.state.montoPago - total;
        this.setState({ vuelto: vuelto > 0 ? vuelto : 0 });
    }

    handleMedioPagoChange = (e) => {
        this.setState({ 
            medioPago: e.target.value,
            montoPago: 0,
            vuelto: 0
        });
    }

    handleMontoPagoChange = (e) => {
        const monto = parseFloat(e.target.value) || 0;
        this.setState({ montoPago: monto }, this.calcularVuelto);
    }

    render() {
        const {productos} = this.props;
        const {medioPago, montoPago, vuelto} = this.state;

        const total = productos.reduce((acc, item) => acc + (item.precio * item.cantidad), 0);
        return(
            <div className="preventa__container_data col-12 col-sm-6 no-pad">
                <div className="abed__preventa__carrito mt-2" style={{maxHeight:"400", overflowY:"auto"}}>
                    <table className="table table-hover" style={{overflow: "hidden"}}>
                        <thead>
                            <tr>
                                <th className="tdDetallePreventa cabecera-tabla" style={{borderRadius: '15px 15px 0 0', backgroundColor: "#01A59C"}}>
                                    <div style={{color:"white", width:"54%"}} className="inputDet">PORDUCTO /PRESENTACION&nbsp;</div>
                                    <div style={{color: "white"}} className='inputDet'>/CANTIDAD</div>
                                    <div style={{color: "white", textAlign:'center'}} className='inputDet'>/ PRECIO</div>
                                    <div style={{color: "white", textAlign:'right'}} className='inputDet'>/ TOTAL</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody id="IdDetProductoCarrito" style={{overflow:"auto"}} >
                            {productos.map((p) => (
                                <tr
                                    key={p.id}
                                    className="prodPreventaTr"
                                    style={{cursor: "pointer", borderBottom: '1px solid #eee'}}
                                    title={`${p.nombre} - ${p.presentacion}`}
                                >
                                    <td >

                                        
                                        <div style={{display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px'}}>
                                            <div style={{fontWeight: 'bold', fontSize: '16px', marginBottom: '10px', color: '#333', textAlign:'center', width:'60%'}}>
                                                {p.nombre} {p.presentacion}
                                            </div>
                                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                                <span style={{fontSize: '16px', marginTop: '5px'}}>{decimalAdjust('floor', p.cantidad, -2)}</span>
                                            </div>
                                            
                                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                                <span style={{fontSize: '16px', marginTop: '5px'}}>S/ {decimalAdjust('floor', p.precio, -2)}</span>
                                            </div>
                                            
                                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                                <span style={{fontSize: '16px', marginTop: '5px'}}>
                                                    S/ {decimalAdjust('floor', p.cantidad * p.precio, -2)}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>  
                <div className="abed__medio-pago mt-4">
                    <div className="abed__card-body">
                        <div className="abed__select_direccion form-group mb-3">
                            <select 
                                id="medioPago"
                                className="input_sin_linea"
                                value={medioPago}
                                onChange={this.handleMedioPagoChange}
                            >
                                <option value="efectivo">Efectivo</option>
                                <option value="tarjeta">Tarjeta</option>
                                <option value="transferencia">Transferencia</option>
                                <option value="yape">Yape</option>
                            </select>
                        </div>

                        <div className="pago-resumen">
                            <div className="abed__resumen-total">
                                <label className="abed__fw-bold">TOTAL:</label>
                                <label className="abed__fw-bold"> S/ {decimalAdjust('floor', total, -2)}</label>
                            </div>

                            {medioPago === 'efectivo' && (
                                <div className="abed__resumen_efectivo form-group">
                                    <label htmlFor="montoPago" className="form-label">PAGA:</label>
                                    <input
                                        className="input"
                                        id="montoPago"
                                        value={montoPago || ''}
                                        onChange={this.handleMontoPagoChange}
                                        min={total}
                                        step="0.01"
                                        style={{background:"transparent", border:"none", textAlign:"right"}}
                                        placeholder="0.00"
                                    />
                                </div>
                            )}

                            <div className="abed__resumen_vuelto">
                                <label className="abed__fw-bold">VUELTO:</label>
                                <label className="abed__fw-bold">S/ {decimalAdjust('floor', vuelto, -2)}</label>
                            </div>

                            {medioPago !== 'efectivo' && (
                                <div className="alert alert-info mt-3">
                                    <small>
                                        {medioPago === 'tarjeta' && 'Se procesará el pago con tarjeta al finalizar la venta.'}
                                        {medioPago === 'transferencia' && 'Se solicitará el comprobante de transferencia al finalizar la venta.'}
                                        {medioPago === 'yape' && 'Se solicitará el comprobante de Yape al finalizar la venta.'}
                                    </small>
                                </div>
                            )}
                        </div>
                    </div>
                    
                </div>
            </div>
        )
    }
}

export default DeliveryAgregarDerecha;